import Error from "../../utils/error.coffee"
import translations from "../../translations"
import * as I18n from "../../services/i18n"

$(document).on 'turbolinks:load', ->
  if $('#form-entities span.error').length > 0
    new Error.show_alert_flash_msg(I18n.t(translations(), 'flash.actions.create.alert', 
      resource_name: I18n.t(translations(), 'obras.details.entity')))